import {useMemo} from 'react';
import {useAppSelector} from 'store/hooks';
import type {EntityStatus, ManifestationStatus} from '../types';
import {getLowestStatus} from '../functions';
import {selectMetadataEditStatuses} from '../metadataEditSlice';

export const useMetadataSavedStatus = (): ManifestationStatus => {
  const statuses = useAppSelector(selectMetadataEditStatuses);

  return useMemo(() => {
    return Object.values(statuses).reduce(
      (acc, s) => {
        return {status: getLowestStatus(acc.status, s.status)} as EntityStatus;
      },
      {status: 'COMPLETED'} as EntityStatus,
    ).status;
  }, [statuses]);
};
